<template>
  <span class="case-cover" :class="'case-cover-' + size">
    <img v-if="image && !failed" :src="value" :alt="alt" @error="failed = true">
    <span v-else class="case-cover-fallback" role="img" :aria-label="alt">{{ fallback }}</span>
  </span>
</template>
<script>
import { isCaseCoverImage } from '../services/caseCover'
import '../assets/case-cover.css'
export default {
  name: 'CaseCover',
  props: { value: String, alt: { type: String, default: '案例封面' }, size: { type: String, default: 'card' } },
  data () { return { failed: false } },
  computed: {
    image () { return isCaseCoverImage(this.value) },
    fallback () { return this.value && this.value.length <= 40 && !/^\s*(data:|https?:)/i.test(this.value) ? this.value : '🧩' }
  },
  watch: { value () { this.failed = false } }
}
</script>
